/* Bogus data for testing Collin's algorithm
I made the scenario M2CA since that scenario has some corresponding log analysis files that can be used
for testing
Ids need to be added to correspond to those in the analysis log*/

export const M2CA_PhaseIE = {
    Action: {
      id: "top",
      label: "Top most node -level 0",
      feedbackAbsent: "Nothing done. Start scenario again.", /*feedback if the action was not performed*/
      feedbackOutOfOrder: "", /*feedback if the action was done late (e.g., if the action is Scene Size-up 
        and it was done after Primary Survey)*/
      feedbackError: "All wrong. Please start scenario again.", /*feedback if the action was performed incorrectly (e.g. wrong Ventilation rate)*/
      subActions: [ /*array with the corresponding subactions (to form the tree)*/
        {
          id: "scene-size-up",
          label: "Child1 -level1",
          feedbackAbsent: "absent -Child1 level 1",
          feedbackOutOfOrder: "late -Child1 level 1",
          feedbackErrors: "wrong -Child1 level 1",
          subActions: [
            {
                id: "assess-scene-safety",
                label: "Child1 of Child1 -level 2",
                feedbackAbsent: "absent -Child1 of Child1 -level2",
                feedbackOutOfOrder: "late -Child1 of Child1 -level2",
                feedbackErrors: "wrong -Child1 of Child1 -level2",
                subActions: [],
                examine: "N",
                prompts: "",
              },
              {
                id: "required-action-BSI",
                label: "Child2 of Child1 -level 2",
                feedbackAbsent: "absent -Child2 of Child1 -level 2",
                feedbackOutOfOrder: "late -Child2 of Child1 -level 2",
                feedbackErrors: "wrong -Child2 of Child1 -level 2",
                subActions: [],
                examine: "Y",
                prompts: "prompts -Child2 of Child1 -level2",
              },
          ],
          examine: "Y",
          prompts: "prompts -Child1 level 1",
        },
        {
          id: "primary-survey",
          label: "Child 2 -level1",
          feedbackAbsent: "absent -Child 2 level1",
          feedbackOutOfOrder: "late -Child 2 level1",
          feedbackErrors: "wrong -Child 2 level1",
          subActions: [
            {
                id: "general-impression",
                label: "Child1 of Child2 -level2",
                feedbackAbsent: "absent -Child1 of Child2 -level2",
                feedbackOutOfOrder: "late -Child1 of Child2 -level2",
                feedbackErrors: "wrong -Child1 of Child2 -level2",
                subActions: [],
                examine: "N",
                prompts: "",
              },
              {
                id: "airway",
                label: "Child2 of child2 -level2",
                feedbackAbsent: "absent -Child2 of Child2 -level2",
                feedbackOutOfOrder: "late -Child2 of Child2 -level2",
                feedbackErrors: "wrong -Child2 of Child2 -level2",
                subActions: [
                    {
                        id: "airway-is-open",
                        label: "Child1 of (Child2 of Child2) -level3",
                        feedbackAbsent: "absent -Child1 of (Child2 of Child2) -level3",
                        feedbackOutOfOrder: "late -Child1 of (Child2 of Child2) -level3",
                        feedbackErrors: "wrong -Child1 of (Child2 of Child2) -level3",
                        subActions: [],
                        examine: "N",
                        prompts: "",
                      },
                      {
                        id: "airway-is-clear-substances",
                        label: "Child2 of (Child2 of Child2) -level3",
                        feedbackAbsent: "absent -Child2 of (Child2 of Child2) -level3",
                        feedbackOutOfOrder: "late -Child2 of (Child2 of Child2) -level3",
                        feedbackErrors: "wrong -Child2 of (Child2 of Child2) -level3",
                        subActions: [],
                        examine: "Y",
                        prompts: "prompts -Child2 of (Child2 of Child2) -level3",
                      }
                ],
                examine: "N",
                prompts: "",
              },
              {
                id: "breathing",
                label: "Child3 of Child2 -level2",
                feedbackAbsent: "absent -Child3 of Child2 -level2",
                feedbackOutOfOrder: "late -Child3 of Child2 -level2",
                feedbackErrors: "wrong -Child3 of Child2 -level2",
                subActions: [],
                examine: "N",
                prompts: "",
              } 
          ],
          examine: "N",
          prompts: "",
        },
        {
          id: "Manage a potential head and/or spinal injury",
          label: "Child 3 -level1",
          feedbackAbsent: "absent -Child 3 level1",
          feedbackOutOfOrder: "late -Child 3 level1",
          feedbackErrors: "wrong -Child 3 level1",
          subActions: [
            {
              id: "intv-spinal-immobilization-technique-cervical-collar",
              label: "Cervical Collar",
              feedbackAbsent: "absent - cervical collar",
              feedbackOutOfOrder: "late - cervical collar",
              feedbackErrors: "wrong - cervical collar",
              subActions: [],
              examine: "Y",
              prompts: "prompts - cervical collar",
            }


          ],
          examine: "N",
          prompts: "",
        },
        {
          id: "ongoing-mgmt-plan",
          label: "Child 4 -level1",
          feedbackAbsent: "absent -Child 4 level1",
          feedbackOutOfOrder: "late -Child 4 level1",
          feedbackErrors: "wrong -Child 4 level1",
          subActions: [
            {
                id: "reassess-vital-signs",
                label: "Child1 of Child4 -level 2",
                feedbackAbsent: "absent -Child1 of Child4 -level2",
                feedbackOutOfOrder: "late -Child1 of Child4 -level2",
                feedbackErrors: "wrong -Child1 of Child4 -level2",
                subActions: [],
                examine: "Y",
                prompts: "prompts -Child1 of Child4 -level2",
              },
              {
                id: "repeat-primary-survey",
                label: "Child2 of Child4 -level 2",
                feedbackAbsent: "absent -Child2 of Child4 -level 2",
                feedbackOutOfOrder: "late -Child2 of Child4 -level 2",
                feedbackErrors: "wrong -Child2 of Child4 -level 2",
                subActions: [],
                examine: "N",
                prompts: "",
              },  
          ],
          examine: "Y",
          prompts: "prompts -Child4 level1",
        },
      ],
      examine: "N", /*Boolean that says whether the action needs to be examined*/
      prompts: "" /*prompts to hint the student as to how to reflect on the action*/
    },
  }